import { RouterActionTypes, SET_ROUTE } from './types';

export const setRoute = (payload: string): RouterActionTypes => ({
  type: SET_ROUTE,
  payload,
});
